import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { Modules } from '../enums/modules.enum';


export const canActivateModuleGuard = (route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const modules: Modules[] = route.data?.['modules'] ?? [];
  const noModulesRequired = modules.length === 0;
  if (noModulesRequired || authService.hasModules(modules)) {
    return true;
  }

  router.navigate(['/not-found']);
  return false;
}

